import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Layout, Spin, message } from 'antd';
import AppHeader from './components/Header';
import AppFooter from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Archive from './pages/Archive';
import PostDetail from './pages/PostDetail';
import Auth from './pages/Auth';
import WritePost from './pages/WritePost';
import NotFound from './pages/NotFound';
import './App.css';

const { Content } = Layout;

function App() {
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkLoginStatus = () => {
      try {
        const userFromStorage = localStorage.getItem('blog_user');
        const token = localStorage.getItem('blog_token');
        
        if (userFromStorage && token) {
          setLoggedInUser(JSON.parse(userFromStorage));
        }
      } catch (error) {
        console.error('解析用户信息失败:', error);
        localStorage.removeItem('blog_user');
        localStorage.removeItem('blog_token');
      } finally {
        setLoading(false);
      }
    };

    setTimeout(() => {
      checkLoginStatus();
    }, 500);
  }, []);

  const handleLogin = (userData, token) => {
    localStorage.setItem('blog_token', token);
    localStorage.setItem('blog_user', JSON.stringify(userData));
    setLoggedInUser(userData);
    message.success('登录成功！');
  };

  const handleLogout = () => {
    localStorage.removeItem('blog_token');
    localStorage.removeItem('blog_user');
    setLoggedInUser(null);
    message.success('已成功登出');
  };

  const handleRegister = (userData, token) => {
    localStorage.setItem('blog_token', token);
    localStorage.setItem('blog_user', JSON.stringify(userData));
    setLoggedInUser(userData);
    message.success('注册成功！');
  };

  const ProtectedRoute = ({ children }) => {
    if (!loggedInUser) {
      return <Navigate to="/auth" replace />;
    }
    return children;
  };

  const GuestRoute = ({ children }) => {
    if (loggedInUser) {
      return <Navigate to="/" replace />;
    }
    return children;
  };

  if (loading) {
    return (
      <div className="app-loading">
        <Spin size="large" tip="加载中..." />
      </div>
    );
  }

  return (
    <Router>
      <Layout className="app-layout app-background-image">
        <AppHeader loggedInUser={loggedInUser} onLogout={handleLogout} />
        <Content className="app-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/archive" element={<Archive />} />
            <Route path="/post/:id" element={<PostDetail />} />
            <Route path="/auth" element={<GuestRoute><Auth onLogin={handleLogin} onRegister={handleRegister} /></GuestRoute>} />
            <Route path="/write" element={<ProtectedRoute><WritePost /></ProtectedRoute>} />
            <Route path="/edit/:id" element={<ProtectedRoute><WritePost isEditMode={true} /></ProtectedRoute>} />
            <Route path="/404" element={<NotFound loggedInUser={loggedInUser} onLogout={handleLogout} />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
        </Content>
        <AppFooter />
      </Layout>
    </Router>
  );
}

export default App;